import React from 'react';
import PropTypes from 'prop-types';

/**
 * Icon — Material Icons 래퍼 컴포넌트
 *
 * Google Material Icons 폰트를 일관되게 사용하기 위한 래퍼.
 * outlined prop에 따라 material-icons / material-icons-outlined 클래스를 전환한다.
 *
 * @param {Object} props
 * @param {string} props.name - Material Icons 아이콘 이름 (예: 'dashboard', 'check_circle')
 * @param {number} [props.size=20] - 아이콘 크기 (px)
 * @param {string} [props.className=''] - 추가 CSS 클래스
 * @param {boolean} [props.outlined=false] - true이면 material-icons-outlined 사용
 * @param {string} [props.color] - 아이콘 색상 (CSS 변수 또는 값)
 * @param {Object} [props.style] - 추가 인라인 스타일
 * @returns {React.ReactElement}
 *
 * 사용 예:
 *   <Icon name="dashboard" />
 *   <Icon name="check_circle" size={24} color="var(--color-success)" />
 *   <Icon name="info" outlined />
 */
const Icon = ({ name, size = 20, className = '', outlined = false, color, style, ...rest }) => {
  const iconClass = outlined ? 'material-icons-outlined' : 'material-icons';

  return (
    <span
      className={`${iconClass} ${className}`}
      style={{ fontSize: `${size}px`, color, ...style }}
      aria-hidden="true"
      {...rest}
    >
      {name}
    </span>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  outlined: PropTypes.bool,
  color: PropTypes.string,
  style: PropTypes.object,
};

export default Icon;
